import {
    DELETE_ORDER,
    GET_ORDER,
    GET_EXPORT_ORDERS,
    UPDATE_ORDER,
    SEND_MAIL,
    SEND_MESSAGE,
    PRINT_RECEIPT,
    ENABLE_DISABLE_FORM,
    SAVEONLINEORDER_MESSAGE,
    ENABLE,
    DISABLE,
    GET_FORM_DETAILS,
    GET_BUSINESS_ORDER_NOTIFICATION_DETAILS,
    SAVE_BUSINESS_ORDER_NOTIFICATION_DETAILS,
    STRIPE_REFUND,
} from './actionTypes';
import axios from "axios";
import axiosI from "../Service/service";
import * as constants from '../Constants';

export const getOrder = (formType, url) => {
    console.log("GET Order URL:-" + url);

    if (formType === 'jotform') {
        return dispatch =>
            axios.get(url).then((response) => {
                dispatch({
                    type: GET_ORDER,
                    payload: response.data.content,
                    formType: formType,
                });
            }).catch((err) => {
                console.log(err);
            });
    } else {
        return dispatch =>
            axiosI.get(url).then((response) => {
                dispatch({
                    type:GET_ORDER,
                    payload: response.data.results.content,
                    totalOrders: response.data.results.TotalRecords,
                    totalAmount: response.data.results.TotalAmount,
                    formType: formType,
                    dropDownValue: url.includes('processing') ? 'Active' : url.includes('Completed') ? 'Completed' : url.includes('Cancelled') ? 'Cancelled' : 'All'
                });
            }).catch((err) => {
                console.log(err);
            });
    }
};

export const getExportOrders = (formType, url) => {
    // console.log("GET Export Order URL:-" + url);
    if (formType === 'jotform') {
        return dispatch =>
            axios.get(url).then((response) => {
                dispatch({
                    type: GET_EXPORT_ORDERS,
                    payload: response.data.content
                });
            }).catch((err) => {
                console.log(err);
            });
    } else {
        return dispatch =>
            axiosI.get(url).then((response) => {
                dispatch({
                    type:GET_EXPORT_ORDERS,
                    payload: response.data.results.content
                });
            }).catch((err) => {
                console.log(err);
            });
    }
};

export const deleteOrder = (url) => {
    // console.log("DELETE URL:-" + url);
    return dispatch =>
        axios.delete(url).then((response) => {
            dispatch({
                type: DELETE_ORDER,
                payload: response.data.content
            });
        }).catch((err) => {
            console.log(err);
        });
};

export const updateOrder = (type, url, dictionary, formType, orderId, extraParam) => {
    // console.log("UPDATE URL:-" + url);
    if (formType === 'jotform') {
        return dispatch =>
            axios.post(url, dictionary, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response) => {
                dispatch({
                    type: UPDATE_ORDER,
                    payload: response.data.content
                });
            }).catch((err) => {
                console.log(err);
            });
    } else {
        var value = ""
        for (var key in dictionary) {
            value = dictionary[key];
        }

        return dispatch => {
            dispatch({type: ENABLE, payload: true});

            return axiosI.post(url,
            {
                type: type,
                orderId: orderId,
                value: value,
                extraParam: extraParam
            }).then((data) => {
                dispatch({
                    type: UPDATE_ORDER,
                    payload: data
                });
                dispatch({type: DISABLE, payload: false});
            }).catch((err) => {
                console.error(err);
            });
        }
    }
};

export const sendMail=(fromUserMail,toUserMail,emailType, businessProfileImage, businessName, businessPhoneno, customerName, orderTime, orderType)=>{

    return (dispatch => {
        dispatch({type: ENABLE, payload: true});

        return axiosI.post(constants.API.callSendMailApi, {fromUserMail: fromUserMail, toUserMail: toUserMail, emailType: emailType,businessProfileImage:businessProfileImage,businessName:businessName, businessPhoneno:businessPhoneno, customerName:customerName, orderTime:orderTime, orderType: orderType}).then(({data})=>{

            dispatch({
                type:SEND_MAIL,
                payload: data
            });
            dispatch({type: DISABLE, payload: false});
            return data;
        })
    })
};

export const sendMessage=(toUserPhonenumber,businessMessage)=>{

    return (dispatch => {
        dispatch({type: ENABLE, payload: true});

        return axiosI.post(constants.API.callSendMessageApi, {toUserPhonenumber: toUserPhonenumber, businessMessage: businessMessage}).then(({data})=>{

            dispatch({
                type:SEND_MESSAGE,
                payload: data
            });
            dispatch({type: DISABLE, payload: false});
            return data;
        })
    })
};

export const printReceipt = (url, dictionary) => {
    // console.log("Print Receipt URL:-" + url);
    return dispatch =>
        axios.post(url, dictionary, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            dispatch({
                type: PRINT_RECEIPT,
                payload: response.data
            });
        }).catch((err) => {
            console.log(err);
        });
};

export const saveOnlineOrderMessage=(businessId, businessMessage)=>{

    return (dispatch => {
        dispatch({type: ENABLE, payload: true});

        return axiosI.post(constants.API.saveOnlineOrderMessageApi, {BusinessID: businessId, businessMessage: businessMessage}).then(({data})=>{

            dispatch({
                type:SAVEONLINEORDER_MESSAGE,
                payload: data
            });
            dispatch({type: DISABLE, payload: false});
            return data;
        })
    })
};

export const stripeRefund=(woocommerceOrderId, transactionId, amount)=>{

    return (dispatch => {
        dispatch({type: ENABLE, payload: true});

        return axiosI.post(constants.API.stripeRefundApi, {woocommerceOrderId: woocommerceOrderId, transactionId: transactionId, amount: amount}).then(({data})=>{

            dispatch({
                type:STRIPE_REFUND,
                payload: data
            });
            dispatch({type: DISABLE, payload: false});
            return data;
        })
    })
};

export const enableDisableForm = (url, dictionary) => {
    // console.log("Enable Disable Form URL:-" + url);
    // console.log("Enable Disable Form Dictionary:-" + dictionary);
    return dispatch =>
        axios.put(url, dictionary, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            dispatch({
                type: ENABLE_DISABLE_FORM,
                payload: response.data.content
            });
        }).catch((err) => {
            console.log(err);
        });
};

export const getFormDetails = (url) => {
    console.log("GET URL:-" + url);
    return dispatch =>
        axios.get(url).then((response) => {
            dispatch({
                type: GET_FORM_DETAILS,
                payload: response.data.content
            });
        }).catch((err) => {
            console.log(err);
        });
};

export const getBusinessOrderNotificationDetails = (businessId) => {

    return (dispatch => {

        return axiosI.get(`${constants.API.getOrderNotificationDetailsApi}/${businessId}`).then((response) => {
            dispatch({
                type:GET_BUSINESS_ORDER_NOTIFICATION_DETAILS,
                payload: response.data
            });
            return response.data;
        })
    })
};

export const saveBusinessOrderNotificationDetails = (businessId, emails, phoneNo, faxNo) => {

    return (dispatch => {
        dispatch({type: ENABLE, payload: true});

        return axiosI.post(constants.API.saveBusinessOrderNotificationDetailsApi, {BusinessID: businessId, Emails: emails, Phones: phoneNo, Faxes: faxNo}).then(({data})=>{

            dispatch({
                type:SAVE_BUSINESS_ORDER_NOTIFICATION_DETAILS,
                payload: data
            });
            dispatch({type: DISABLE, payload: false});
            return data;
        })
    })
};